import Vapi from "vuex-rest-api"
import Ride from "../models/Ride"
import { TimeOfDay } from "../models/TimeOfDay";
import { Guid } from 'guid-typescript';
import AppEvents from '@/AppEvents';

const rideApi = new Vapi({
    baseURL: process.env.VUE_APP_API_HOST + "/api/ride",
    state: {
        rides: [],
    }
})
    .get({
        action: "getAllRides",
        property: "rides",
        path: "/",
        onSuccess: (state, payload, axios) => {
            // console.log("getAllRides onSuccess", state, payload.data);
            state.rides = payload.data.map(s => Ride.fromApi(s));
            // console.log("state.rides is now:", state.rides);
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .get({
        action: "getDestinationRides",
        property: "rides",
        path: ({ destinationId }) => ("/destination/" + destinationId),
        onSuccess: (state, payload, axios) => {
            // console.log("getDestinationRides onSuccess", state, payload.data);
            const apiRides: any[] = payload.data;
            apiRides.forEach((apiRide: any) => {
                const newRide =  Ride.fromApi(apiRide);
                const index: number = state.rides.findIndex(r => r.id === newRide.id);
                if (index > -1){
                    // arrivalDeparture already exists, update props
                    Object.assign(state.rides[index], newRide);
                } else {
                    // arrivalDeparture does not exists, push it to the store
                    state.rides.push(newRide);
                }
            });
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .get({
        action: "getRideById",
        property: "ride",
        path: ({ id }) => ("/" + id),
        onSuccess: (state, payload, axios) => {
            // console.log("updateRide onSuccess", state, payload.data);
            const ride: Ride = Ride.fromApi(payload.data);
            const rideIndex: number = state.rides.findIndex(p => p.id === ride.id);
            if (rideIndex > -1) {
                // ride already exists, update props
                Object.assign(state.rides[rideIndex], ride);
            } else {
                // ride doesn't exist, push it to rides
                state.rides.push(ride);
            }
            // console.log("state.rides is now:", state.rides);
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .post({
        action: "createRide",
        property: "ride",
        path: "/",
        onSuccess: (state, payload, axios) => {
            // console.log("createRide onSuccess", state, payload.data);
            state.rides.push(Ride.fromApi(payload.data));
            // console.log("state.rides is now:", state.rides);
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .post({
        action: "createRides",
        property: "rides",
        path: "/createMany",
        beforeRequest: (state, payload) => {
            const tempApiRides: any[] = payload.data;
            tempApiRides.forEach((tempApiride: any) => {
                tempApiride.creatingId = Guid.create().toString();
                tempApiride.creating = true;
            });
            const tempRides: Ride[] = tempApiRides.map(apiRide => Ride.fromApi(apiRide)); 
            state.rides.push(...tempRides);
        },
        onSuccess: (state, payload, axios) => {
            // console.log("createRides onSuccess", state, payload.data);
            const newApiRides: any[] = payload.data;
            const newRides: Ride[] = newApiRides.map(apiRide => Ride.fromApi(apiRide)); 
            newRides.forEach((createdRide: Ride) => {
                const rideIndex: number = state.rides
                .findIndex((r: Ride) => r.creatingId && r.creatingId === createdRide.creatingId);
                if (rideIndex > -1){
                    // ride already exists, update props
                    Object.assign(state.rides[rideIndex], createdRide);
                    const ride: Ride = state.rides[rideIndex];
                    delete ride.creatingId;
                    ride.creating = false;
                    return;
                }
            });
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .post({
        action: "createOrUpdateRides",
        property: "rides",
        path: "/createOrUpdateMany",
        beforeRequest: (state, payload) => {
            const tempApiRides: any[] = payload.data;
            const tempRidesCreating: Ride[] = tempApiRides
            .filter(r => r.creating)
            .map(apiRide => Ride.fromApi(apiRide)); 
            state.rides.push(...tempRidesCreating);
        },
        onSuccess: (state, payload, axios) => {
            // console.log("createRides onSuccess", state, payload.data);
            const newApiRides: any[] = payload.data;
            const newRides: Ride[] = newApiRides.map(apiRide => Ride.fromApi(apiRide)); 
            newRides.forEach((createdOrUpdatedRide: Ride) => {
                // Update rides in state with updated rides from API
                const rideIndex: number = state.rides
                .findIndex(r => 
                    (r.creatingId && r.creatingId === createdOrUpdatedRide.creatingId)
                    || r.id === createdOrUpdatedRide.id);
                if (rideIndex > -1){
                    // ride already exists, update props
                    Object.assign(state.rides[rideIndex], createdOrUpdatedRide);
                    const ride = state.rides[rideIndex];
                    delete ride.creatingId;
                    ride.creating = false;
                    ride.updating = false;
                    return;
                }
            });
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .put({
        action: "updateRide",
        property: "ride",
        path: ({ id }) => ("/" + id),
        onSuccess: (state, payload, axios) => {
            // console.log("updateRide onSuccess", state, payload.data);
            const ride: Ride = Ride.fromApi(payload.data);
            const rideIndex: number = state.rides.findIndex(p => p.id === ride.id);

            // ride already exists, update props
            Object.assign(state.rides[rideIndex], ride);
            ride.updating = false;
            // console.log("state.rides is now:", state.rides);
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .post({
        action: "updateRides",
        property: "rides",
        path: "/updateMany",
        onSuccess: (state, payload, axios) => {
            // console.log("updateRides onSuccess", state, payload.data);
            // console.log("state.rides is before:", state.rides);
            // rides already exist, update props
            const updatedRides: Ride[] = payload.data.map(s => Ride.fromApi(s));
            updatedRides.forEach((updatedRide: Ride) => {
                const rideIndex: number = state.rides.findIndex(p => p.id === updatedRide.id);
                // ride already exists, update props
                Object.assign(state.rides[rideIndex], updatedRide);
                const ride: Ride = state.rides[rideIndex];
                ride.updating = false;
            });
            // console.log("state.rides is now:", state.rides);
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .delete({
        action: "deleteRide",
        property: "ride",
        path: ({ id }) => ("/" + id),
        onSuccess: (state, payload, axios) => {
            // console.log("deleteRide onSuccess", state, payload.data);
            // TODO: We should be receiving an "ok, deleted id [id_here]" response
            // Now, we should find the deleted ride locally and delete it from state.rides
            const rideId: Guid = payload.data;
            const rideIndex: number = state.rides.findIndex(p => p.id === rideId);
            state.rides.splice(rideIndex, 1);
            // console.log("state.rides is now:", state.rides);
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    // Note: This could be .delete, but axios does not allow body in HttpDelete requests
    .post({
        action: "deleteRides",
        property: "rides",
        path: "/deleteMany",
        onSuccess: (state, payload, axios) => {
            // console.log("deleteRides onSuccess", state, payload.data);
            // TODO: We should be receiving an "ok, deleted ids [id_here]" response
            // Now, we should find the deleted rides locally and delete it from state.rides
            const rideIds: Guid[] = payload.data;
            rideIds.forEach(rideId => {
                const rideIndex: number = state.rides.findIndex(p => p.id === rideId);
                state.rides.splice(rideIndex, 1);
            });
            
            // console.log("state.rides is now:", state.rides);
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })

const rideStore = rideApi.getStore();
(rideStore as any).namespaced = true;

export default rideStore;
